import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
import { ref, watch } from "vue";
import JsonDrawer from "../drawer/JsonDrawer.vue";
import { useErrorDetail } from "./useErrorDetail";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationApp',
    setup(__props) {
        const isDrawerOpen = ref(false);
        const { error, clearError } = useErrorDetail();
        watch(() => error.value, (value) => {
            if (value) {
                isDrawerOpen.value = true;
            }
            else {
                isDrawerOpen.value = false;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (isDrawerOpen.value && _unref(error))
                    ? (_openBlock(), _createBlock(JsonDrawer, {
                        key: 0,
                        data: _unref(error),
                        title: 'Error Details',
                        onClosed: _cache[0] || (_cache[0] = ($event) => {
                            _unref(clearError)();
                        })
                    }, null, 8 /* PROPS */, ["data"]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
